import { actionTypes } from "./companyActionTypes";
import * as State from "./companyInitialState";

export default function companyReducer(state = State.INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.LOADING:
      return {
        ...state,
        loading: action.value,
      };
    case actionTypes.SET_SELECTED_COMPANY:
      return {
        ...state,
        selectedCompany: action.Name,
        companyId: action.value.Id,
        isCompanySelected: true,
      };
    case actionTypes.CLEAR_COMPANY_ERRORS:
      return {
        ...state,
        companyErrors: { ...state.companyErrors },
      };
    case actionTypes.CLEAR_SELECTED_COMPANY:
      return {
        ...state,
        selectedCompany: "",
        companyId: "",
        isCompanySelected: false,
      };
    case actionTypes.SET_COMPANIES:
      return {
        ...state,
        companies: action.companies,
      };
    default:
      return {
        ...state,
      };
  }
}
